(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EXCLUDED_SELECTOR = '.shopify-section-header, .shopify-section-footer, .shopify-section-announcement-bar, .shopify-section-group-header-group, .shopify-section-group-footer-group, [data-entry-page-root]';

  function isExcluded(el) {
    return el.matches(EXCLUDED_SELECTOR) || el.querySelector('.entry-page') !== null;
  }

  function setup() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    sections = sections.filter(function (el) {
      return !isExcluded(el);
    });

    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('as-reveal--in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section, index) {
      section.classList.add('as-reveal');
      section.style.setProperty('--as-reveal-delay', Math.min(index, 4) * 60 + 'ms');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
